import type { SxProps, Theme } from '@mui/material/styles';

import { fontFamilies } from '../../../theme';

export const legalDisclaimerPanelStyles: Record<string, SxProps<Theme>> = {
  paper: (theme) => ({
    width: { xs: '100%', md: 460 },
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
  }),
  header: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
  title: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1.0625rem',
    color: theme.palette.text.primary,
    margin: 0,
  }),
  close: (theme) => ({ color: theme.palette.text.secondary }),
  body: (theme) => ({
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
  }),
  // Figma: Inter Regular 12 / 100%, 0 letter-spacing, text-tertiary (600).
  paragraph: (theme) => ({
    fontFamily: fontFamilies.legal,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: theme.palette.surface.legalText,
  }),
  link: (theme) => ({
    fontFamily: fontFamilies.legal,
    fontWeight: 400,
    fontSize: '0.75rem',
    color: theme.palette.surface.legalText,
    textDecoration: 'underline',
    '&:hover': { color: theme.palette.surface.legalText },
  }),
};
